import { Tag } from "@brg/api";
import { BTag, FlexBox, GridBox } from "@brg/ui";
import { bTag } from "core";
import { BTagsGrid } from "core/components";
import { DesignerTagsContainer } from "./styles";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";

export const DesignerTags = ({ tags }: { tags: Tag<'Local'>[] }) => {
    const history = useHistory();
    return (
        <DesignerTagsContainer>
            <FlexBox direction="column" className="designer-tags-container">
                {tags.map((tag) => (
                    <BTag key={tag.tagId} tag={tag} isCoauthorTag onClick={() => history.push(CreateLinkTo.tag(tag.tagId))}>
                        {bTag.title(tag)}
                    </BTag>
                ))}
            </FlexBox>
        </DesignerTagsContainer>    
    )
}import { Tag } from "@brg/api";
import { BTag, FlexBox, GridBox } from "@brg/ui";
import { bTag } from "core";
import { BTagsGrid } from "core/components";
import { DesignerTagsContainer } from "./styles";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";

export const DesignerTags = ({ tags }: { tags: Tag<'Local'>[] }) => {
    const history = useHistory();
    return (
        <DesignerTagsContainer>
            <FlexBox direction="column" className="designer-tags-container">
                {tags.map((tag) => (
                    <BTag key={tag.tagId} tag={tag} isCoauthorTag onClick={() => history.push(CreateLinkTo.tag(tag.tagId))}>
                        {bTag.title(tag)}
                    </BTag>
                ))}
            </FlexBox>
        </DesignerTagsContainer>    
    )
}